<main id="project_institutional">
  <h1 class="title_Institutional">Mídia</h1>

  <section id="page_main">
    <h1 class="title-blue">Video Institucional</h1>

    <iframe
      src="https://www.youtube.com/embed/rMB_XDkL7s8?si=GIMkcwjlzL0iwciM"
      title="TV PUC-Rio | Fundação Padre Leonel Franca faz 40 anos"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    ></iframe>

    <iframe
      src="https://www.youtube.com/embed/qsl9tD7gd84?si=m6zf6kP8KXe7iDYL"
      title="TV PUC-Rio | Fundação Padre Leonel Franca faz 40 anos"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    ></iframe>
  </section>

  <section id="second_page">
    <h1 class="title-blue">Galeria Institucional</h1>

    <div class="card" *ngFor="let obj of carrousels">
      <h5 class="title-pink" [innerHTML]="obj.title"></h5>
      <swiper
        class="carrousel"
        data-aos="fade-up"
        data-aos-delay="100"
        [loop]="true"
        [slidesPerView]="'auto'"
        [spaceBetween]="10"
        [mousewheel]="true"
        [pagination]="{ clickable: true }"
        [autoplay]="{ delay: 3000, disableOnInteraction: false }"
        class="mySwiper"
      >
        <ng-template swiperSlide *ngFor="let obj of obj.images">
          <figure>
            <img [src]="obj" alt="" />
          </figure>
        </ng-template>
      </swiper>
    </div>
  </section>
</main>
